export const initialState = {
    "schoolCodeModal" : false,
    "linkSchoolCodeStatus" :false,
    "currentMode" : null,
    "cmfAttempt" : null,
};
